import { makeStyles } from '@material-ui/core'
export const dashboardStyles = makeStyles((theme) => ({
    headerWrapper: {
        padding: theme.spacing(1),
        marginBottom: '20px',
    },
    image: {
        margin: '0px 0px 10px 8px',
    },
    section: {
        marginTop: '10px',
        marginBottom: '20px',
        // width: '100%',
    },
    passwordSection: {
        marginTop: '10px',
        // marginBottom: '20px',
        width: '100%',
        height: '55px',
    },
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    uploadInput: {
        display: 'none',
    },
    saveBtn: {
        justifyContent: 'start',
        marginTop: '10px',
    },
    logo: {
      maxHeight: '58px',
    },
    texts: {
        backgroundColor: '#f5f5f5', 
        borderRadius: theme.shape.borderRadius, 
        border: '1px solid #ddd',
        width: '100%',
        maxHeight: '650px',
        height: '30vw',
        overflowY: 'auto',
        marginLeft: '8px',
        '& .MuiFilledInput-root': {
            backgroundColor: '#f5f5f5', 
            borderRadius: theme.shape.borderRadius, 
            paddingBottom: '6px',
            boxShadow: 'none',
            '&:before, &:after': {
                display: 'none', 
            },
        },
        '& .MuiInputLabel-root': {
            top: '-7px', 
            fontSize: '0.9rem', 
            // color: '#9e9e9e',
        },
        '& .MuiSelect-icon': {
            top: 'calc(50% - 12px)',
        },

    },
    textWrapper: {
        marginLeft: 'auto',
    },
    inputIconRight: {
        color: 'white',
        opacity: '0.3',
        height: '17px',
        float: 'right',
        marginRight: '5px',
        position: 'relative',
        bottom: '30px',
        filter: 'brightness(0)',
    },
    button: {
        marginLeft: '30px',
        marginTop: '66px',
        width: '100px',
    },
    passwordWrapper: {
      position: 'relative',
    },
    input: {
        backgroundColor: '#f5f5f5', 
        borderRadius: theme.shape.borderRadius, 
        overflow: 'hidden',
        border: '1px solid #ddd',
        marginLeft: '8px',
        '& .MuiFilledInput-root': {
            backgroundColor: '#f5f5f5', 
            borderRadius: theme.shape.borderRadius, 
            paddingBottom: '6px',
            height: '40px',
            boxShadow: 'none',
            '&:before, &:after': {
                display: 'none', 
            },
        },
        '& .MuiInputLabel-root': {
            top: '-7px', 
            fontSize: '0.9rem', 
            // color: '#9e9e9e',
        },
        '& .MuiSelect-icon': {
            top: 'calc(50% - 12px)',
        },
    },
    inputFull: {
        backgroundColor: '#f5f5f5', 
        borderRadius: theme.shape.borderRadius, 
        overflow: 'hidden',
        border: '1px solid #ddd',
        marginLeft: '8px',
        width: 'calc(100% - 8px)',
        '& .MuiFilledInput-root': {
            backgroundColor: '#f5f5f5', 
            borderRadius: theme.shape.borderRadius, 
            paddingBottom: '6px',
            height: '40px',
            boxShadow: 'none',
            '&:before, &:after': {
                display: 'none', 
            },
        },
        '& .MuiInputLabel-root': {
            top: '-7px', 
            fontSize: '0.9rem', 
            // color: '#9e9e9e',
        },
        '& .MuiSelect-icon': {
            top: 'calc(50% - 12px)',
        },
    }
}))
